import "devextreme/dist/css/dx.light.css";
import React, { useState } from "react";
import { Toolbar, Item } from "devextreme-react/toolbar";
import "./header.css";

function Header({isOpened, setIsOpened}) {
  const handleItem = () => {
    console.log("Handle Click");
  };
  const handleDrawer = () => {
    setIsOpened(!isOpened);
  };

  return (
    <div className="header-container">
      <Toolbar
        id="toolbar"
        className="dx-theme-background-color toolbar-with-shadow header-background-color"
      >
        <Item
          location="before"
          widget="dxButton"
          options={{
            icon: "menu",
            stylingMode: "text",
            iconColor: "#03a9f4",
            onClick: handleDrawer,
          }}
        />
        {/* <Item
          location="before"
          render={() => (
            <img
              src="../../assets/Favicon-64x64.png"
              alt="Brand Logo"
              className="brand-logo-image"
            />
          )}
        /> */}
        <Item
          location="before"
          locateInMenu="never"
          render={() => (
            <div className="dashboard-studio-text">Dashboard Studio</div>
          )}
        />
        <Item
          location="after"
          widget="dxButton"
          options={{
            icon: "find",
            stylingMode: "text",
            onClick: handleItem,
          }}
          className="header-options-style"
        />
        <Item
          location="after"
          widget="dxButton"
          options={{
            icon: "help",
            stylingMode: "text",
            onClick: handleItem,
          }}
          className="header-options-style"
        />
        <Item
          location="after"
          widget="dxButton"
          options={{
            icon: "user",
            stylingMode: "text",
            onClick: handleItem,
          }}
          className="header-options-style"
        />
      </Toolbar>
    </div>
  );
}

export default Header;
